import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-rise-notail",
  "use": "icon-arrow-rise-notail-usage",
  "viewBox": "0 0 10 9",
  "content": "<symbol viewBox=\"0 0 10 9\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-rise-notail\">\n<path d=\"M0 8.364L4.836 0L9.66 8.364H0Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/arrow-rise-notail.svg
// module id = lmjp
// module chunks = 258